import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { TranslationLanguage } from '@stream-io/video-react-sdk';
const LANGUAGE_SETTINGS_KEY = '@pronto/lng-settings';
export const useLanguage = () => {
  const $ = _c(5);
  const [language, setLanguage] = useState(_temp);
  let t0;
  let t1;
  if ($[0] !== language) {
    t0 = () => {
      storeLanguage(language);
    };
    t1 = [language];
    $[0] = language;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== language) {
    t2 = {
      language,
      fallbackLanguage: "en",
      setLanguage
    };
    $[3] = language;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const storeLanguage = (lng: TranslationLanguage) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LANGUAGE_SETTINGS_KEY, lng);
  } catch (e) {
    console.warn(`Language couldn't be stored`, e);
  }
};
const getStoredLanguage = () => {
  if (typeof window === 'undefined') return;
  try {
    return window.localStorage.getItem(LANGUAGE_SETTINGS_KEY);
  } catch (e) {
    console.warn(`Language couldn't be retrieved`, e);
  }
};
function _temp() {
  return getStoredLanguage() || (typeof window !== "undefined" ? window.navigator.language : "en");
}